import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchArtifactObjectUrl } from '../../api/arena'

/** Renders a video-result artifact by fetching it (auth'd) as a blob. */
export function ArtifactVideo({ resultId }: { resultId: string }) {
  const { t } = useTranslation('shared')
  const [url, setUrl] = useState<string | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    let objectUrl: string | null = null
    setUrl(null)
    setError(false)
    fetchArtifactObjectUrl(resultId)
      .then((u) => {
        if (cancelled) {
          URL.revokeObjectURL(u)
          return
        }
        objectUrl = u
        setUrl(u)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [resultId])

  if (error) return <div className="text-xs font-medium text-red-400">{t('artifactVideo.unavailable')}</div>
  if (!url) return <div className="text-xs font-medium text-muted-foreground">{t('artifactVideo.loading')}</div>
  return (
    <video
      src={url}
      controls
      loop
      playsInline
      className="w-full rounded-md border border-border-subtle"
    />
  )
}
